const shopnow = {
  "showNow.title": "ช้อปเลย",
  "showNow.physical.details": "ค้นหาร้านค้าใกล้คุณ",
  "buttonText.findStores": "ค้นหาร้านค้า",
}

const download_now = {
  "download_now.title": "สมาชิกใหม่รับส่วนลดทันที 500 บาท",
  "download_now.p": "สมัครสมาชิก มายแอคคิววิว เพื่อรับสิทธิพิเศษ",
  "download_now.button": "เรียนรู้เพิ่มเติม",
}



const app_promo = {
  "app_promo.block_title": "<span>รับสิทธิพิเศษสมาชิกมากมาย​</span> <span><em>ผ่านไลน์มายแอคคิววิว​</em></span>",
  "app_promo.acuvue": "@ACUVUE​",
  "app_promo.li_01": "รับส่วนลด และข้อเสนอสุดพิเศษเฉพาะสมาชิก",
  "app_promo.li_02": "รับคะแนนสะสมทุกการซื้อ",
  "app_promo.li_03": "แลกคะแนนรับคูปองเงินสดแอคคิววิวหรือส่วนลดจากร้านค้าที่ร่วมรายการ",
  "app_promo.cta_title": "สมาชิกใหม่รับส่วนลดทันที 500 บาท",
  "app_promo.cta_btn": "<a>เรียนรู้เพิ่มเติม</a>",
  "app_promo.cta_link": "https://www.acuvue.co.th/acuvuemember"
}

export default {
...shopnow,
...download_now,
...app_promo,
};

